import type { ListingItem } from '@smg-real-estate/hg-search-libs';

import type { AgencyAgent } from '@/types-agency';
import type { ReferenceListing } from '@/types-reference-listing';

export enum WinningMandateStep {
  GetStarted = 1,
  SellerInfo = 2,
  YourProfile = 3,
  Send = 4,
}

export type WinningMandateListingSource = 'reference' | 'active';

export interface WinningMandateSelectedReferenceListing {
  source: 'reference';
  listing: ReferenceListing;
}

export interface WinningMandateSelectedActiveListing {
  source: 'active';
  listing: ListingItem;
}

export type WinningMandateSelectedListing =
  | WinningMandateSelectedReferenceListing
  | WinningMandateSelectedActiveListing;

export interface WinningMandateProfileChipVisibility {
  sales: boolean;
  listings: boolean;
  teamSize: boolean;
}

export interface WinningMandateLocation {
  lat?: number;
  lon?: number;
  countryCode?: string;
  postalCode?: string;
  city?: string;
  street?: string;
  formattedAddress?: string;
}

export interface WinningMandateFormData {
  sellerFirstName: string;
  sellerLastName: string;
  propertyAddress: WinningMandateLocation | null;
  includeLocationReport: boolean;
  includeHedonicValuation: boolean;
  hedonicValuationFile: File | null;
  selectedAgent: AgencyAgent | null;
  selectedListings: WinningMandateSelectedListing[];
  salesCount: number;
  listingsCount: number;
  teamSize: number;
}
